module.exports = __webpack_public_path__ + "static/media/FFC_Logo_Circle_Navy.3aef79b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/FFC_Logo_Circle_Navy.png
// module id = 667
// module chunks = 0